module.exports = __webpack_public_path__ + "static/media/mobile.369b0d67.png";